import * as actionTypes from "../actions/types";
import axios from "../../axios";
import axiosAuth from "../../axiosAuth";
import { closeMainModal, openEdifySpinner, openMainModal, openInviteToRegisterModal, openWorkBagSuccessModal } from "./profileActions";
import { viewAccessRequest } from "./authActions";
import { loadUserData, activateFreeTrialAuth } from "./authActions";
import { resetOnboarding } from "../onboardingV2/actions.ts";
import { fireAnalytics } from "../../utils/firebase";
import { refetchPortfolios } from "./dashboardActions";
import { getSessionId, getDeviceCategory } from "../../utils/analyticsHelpers.ts";

// Función helper para obtener el email del registro desde localStorage
export const getRegistrationEmail = () => {
  return localStorage.getItem("EmailRegister");
};

// Función helper para limpiar el email del registro
export const clearRegistrationEmail = () => {
  localStorage.removeItem("EmailRegister");
};

export const setImage = (file) => {
  return {
    type: actionTypes.SET_FILE,
    payload: file,
  };
};

const setPortfolioToReducer = (data) => {
  return {
    type: actionTypes.SET_PORTFOLIO,
    payload: data,
  };
};

const setSkillsToReducer = (data) => {
  return {
    type: actionTypes.SET_SKILLS,
    payload: data,
  };
};

export const resetWorkOfferPostulation = () => {
  return {
    type: actionTypes.SEND_WORK_OFFER_POSTULATION,
    payload: false,
  };
};

export const fetchIdentityPhotosRequest = () => {
  return {
    type: actionTypes.FETCH_IDENTITY_PHOTOS_WORKERS_REQUEST
  }
}

export const FetchIdentityPhotosSuccess = (data) => {

  return {
    type: actionTypes.FETCH_IDENTITY_PHOTOS_WORKERS_SUCCESS,
    payload: data
  }
}

export const FetchIdentityPhotosFailure = ({ error }) => {
  return {
    type: actionTypes.FETCH_IDENTITY_PHOTOS_WORKERS_FAILURE,
    error: error
  }
}

export const openIdentityModal = (value, email) => {
  return {
    type: actionTypes.OPEN_IDENTITY_MODAL,
    payload: value,
    email: email
  }
}

export const closeAll = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CLOSE_MODAL });
    dispatch({ type: actionTypes.CLOSE_EDIT_PROFILE_SKILL });
    dispatch({ type: actionTypes.CLOSE_EDIT_PROFILE_DATA });
  };
};


export const getPortfolio = (userId) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  const url = userId ? `/portfolio/user?userFind=${userId}` : "/portfolio/user";
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_PORTFOLIO_LOADING,
      payload: true,
    });
    axios
      .get(url, bearerToken)
      .then((res) => {
        dispatch(setPortfolioToReducer(res.data));
        dispatch({
          type: actionTypes.GET_PORTFOLIO_LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: actionTypes.GET_PORTFOLIO_LOADING,
          payload: false,
        });
      });
  };
};

export const setPortfolio = (portfolioForm, files) => {
  const formData = new FormData();

  files.forEach((image) => {
    formData.append("images", image);
  });
  formData.append("name", portfolioForm.name);
  formData.append("startDate", portfolioForm.startDate);
  formData.append("endDate", portfolioForm.endDate);
  formData.append("description", portfolioForm.description);
  formData.append("zone", portfolioForm.zone);
  formData.append("type", portfolioForm.type);
  formData.append("priceUnit", portfolioForm.priceUnit);
  formData.append("price", portfolioForm.price);
  formData.append("currencyType", portfolioForm.currencyType);


  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch, getState) => {
    dispatch(openEdifySpinner(true));     
    axios
      .post("/portfolio/assign", formData, bearerToken)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        
        // Evento de analytics para producto/servicio creado
        const userData = getState().general.userData;
        fireAnalytics("product_or_service_created", {
          edify_user_id: userData?.id || "",
          session_id: getSessionId(),
          device_category: getDeviceCategory(),
          category: "publishing",
          action: "product_or_service_created",
          portfolio_type: portfolioForm.type || "",
          portfolio_id: res.data?.id || ""
        });
        
        dispatch(
          openMainModal({
            title: `¡Acabas de crear un nuevo ${portfolioForm.type === "producto" ? "producto" : "servicio"} en edify!`,
            body: `El ${portfolioForm.type === "producto" ? "producto" : "servicio"} ya se encuentra publicado en edify y podrá ser visto por toda la comunidad.`,
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
        dispatch(getPortfolio());
        // Actualizar todos los portfolios para que aparezca en el feed
        dispatch(refetchPortfolios());
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModal({
            title: "¡Ups!",
            body: "No hemos podido procesar la carga de tu portafolio, por favor inténtalo nuevamente en unos minutos o escríbenos a contacto@edify.la ¡Muchas gracias!",
            iconType: "error",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      });
  };
};

export const deletePortfolio = (id, navigate) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  return (dispatch) => {
    axios
      .delete("/portfolio/delete", {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          idPortfolio: +id,
        },
      })
      .then((res) => {
        dispatch(getPortfolio());
        // Actualizar todos los portfolios para que la eliminación se refleje en el feed
        dispatch(refetchPortfolios());
        dispatch(
          openMainModal({
            title: "¡Acabas de eliminar tu portafolio!",
            body: "El portafolio ya no estará visible en tu perfil",
            isSuccess: true,
            iconType: "success",
            confirmHandler: null,
          })
        );
      })
      .catch((err) => {
        dispatch(
          openMainModal({
            title: "¡Error!",
            body: "No pudimos eliminar el portafolio. Por favor vuelve a intentarlo mas tarde.",
            iconType: "error",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      });
  };
};

const deletePortfolioImagesBatch = async (imageIds, authToken) => {
  const errors = [];
  for (const imageId of imageIds) {
    try {
      await axios.delete("/portfolio/deletePortfoliotImage", {
        headers: { Authorization: `Bearer ${authToken}` },
        data: { id: imageId },
      });
    } catch (err) {
      errors.push({ id: imageId, error: err });
    }
  }
  return errors;
};

export const updatePortfolio = (portfolioForm, newImages, id, imagesToDelete = []) => {
  const formData = new FormData();
  let updatedAt = new Date();

  formData.append("name", portfolioForm.name);
  formData.append("startDate", portfolioForm.startDate);
  formData.append("endDate", portfolioForm.endDate);
  formData.append("description", portfolioForm.description);
  formData.append("zone", portfolioForm.zone);
  formData.append("type", portfolioForm.type);
  formData.append("priceUnit", portfolioForm.priceUnit);
  formData.append("price", portfolioForm.price);
  formData.append("currencyType", portfolioForm.currencyType);
  formData.append("updatedAt", updatedAt.toISOString());

  if (newImages.length > 0) {
    newImages.forEach((image) => {
      formData.append(`images`, image);
    });
  }

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = {
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return async (dispatch) => {
    dispatch(openEdifySpinner(true));

    try {
      let deleteErrors = [];
      if (imagesToDelete.length > 0) {
        deleteErrors = await deletePortfolioImagesBatch(imagesToDelete, authToken);
        if (deleteErrors.length > 0) {
          console.warn("Algunas imágenes no pudieron ser eliminadas:", deleteErrors);
        }
      }

      await axios.patch(`/portfolio/update/${id}`, formData, bearerToken);
      
      dispatch(openEdifySpinner(false));
      dispatch(getPortfolio());
      dispatch(refetchPortfolios());
      
      if (deleteErrors.length > 0) {
        dispatch(
          openMainModal({
            title: `¡${portfolioForm.type === "producto" ? "Producto" : "Servicio"} actualizado con éxito!`,
            body: "Los cambios ya están visibles en tu perfil. Nota: algunas imágenes no pudieron ser eliminadas. Puedes intentar eliminarlas nuevamente más tarde.",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      } else {
        dispatch(
          openMainModal({
            title: `¡${portfolioForm.type === "producto" ? "Producto" : "Servicio"} actualizado con éxito!`,
            body: "Los cambios ya están visibles en tu perfil y serán visibles para toda la comunidad.",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      }
    } catch (err) {
      console.error("Error updating portfolio:", err);
      dispatch(openEdifySpinner(false));
      
      let errorTitle = "Error al actualizar";
      let errorMessage = "No pudimos actualizar los cambios. Por favor, verifica que todos los campos estén completos correctamente e intenta nuevamente.";
      
      if (err.response) {
        const status = err.response.status;
        const backendMessage = err.response.data?.message || err.response.data?.error;
        
        switch (status) {
          case 400:
            errorTitle = "Datos inválidos";
            errorMessage = backendMessage || "Algunos de los datos ingresados no son válidos. Por favor, revisa los campos e intenta nuevamente.";
            break;
          case 401:
            errorTitle = "Sesión expirada";
            errorMessage = "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.";
            break;
          case 403:
            errorTitle = "Sin permisos";
            errorMessage = "No tienes permisos para actualizar este elemento. Verifica que seas el propietario.";
            break;
          case 404:
            errorTitle = "No encontrado";
            errorMessage = "No se encontró el elemento que intentas actualizar. Es posible que haya sido eliminado.";
            break;
          case 413:
            errorTitle = "Archivos muy grandes";
            errorMessage = "El tamaño de las imágenes es demasiado grande. Por favor, reduce el tamaño de las imágenes e intenta nuevamente.";
            break;
          case 422:
            errorTitle = "Error de validación";
            errorMessage = backendMessage || "Los datos ingresados no cumplen con los requisitos. Por favor, revisa todos los campos.";
            break;
          case 500:
          case 502:
          case 503:
            errorTitle = "Error del servidor";
            errorMessage = "Estamos experimentando problemas técnicos. Por favor, intenta nuevamente en unos minutos. Si el problema persiste, contáctanos a contacto@edify.la";
            break;
          default:
            if (backendMessage) {
              errorMessage = backendMessage;
            } else {
              errorMessage = `Ocurrió un error inesperado (${status}). Por favor, intenta nuevamente o contacta a soporte si el problema persiste.`;
            }
        }
      } else if (err.request) {
        errorTitle = "Error de conexión";
        errorMessage = "No pudimos conectar con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente.";
      } else if (err.message) {
        errorMessage = `Error: ${err.message}`;
      }
      
      dispatch(
        openMainModal({
          title: errorTitle,
          body: errorMessage,
          iconType: "error",
          isSuccess: true,
          confirmHandler: null,
        })
      );
    }
  };
};

//Borrar imagenes de portfolio

export const deleteImageFromPortfolio = (id) => {
  let authToken = localStorage.getItem("access-Token-Edify");

  return (dispatch) => {
    axios
      .delete("/portfolio/deletePortfoliotImage", {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          id: id,
        },
      })
      .then((res) => {
        dispatch(getPortfolio());
        dispatch(
          openMainModal({
            title: "¡Acabas de eliminar una imagen de tu portafolio!",
            body: "La imagen ya no estará visible en tu perfil",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );

      })
      .catch((err) => {
        dispatch(
          openMainModal({
            title: "¡Error!",
            iconType: "error",
            body: "No pudimos eliminar la imagen. Por favor vuelve a intentarlo mas tarde.",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      });
  };
};

//Bolsa de Trabajo 

//Trae todas las ciudades de una jurisdicción
export const getCities = (id) => {

  const sendUrl = `/bolsa-de-trabajo/list?province=${id}`;

  return (dispatch) => {
    axios
      .post(sendUrl, {}, {
        headers: {
          Authorization: "Basic ZWRpZnk6bGFjbGF2ZXNlY3JldGExMjM0",
        },
      })
      .then((res) => {
        dispatch({
          type: actionTypes.GET_CITIES,
          payload: res.data.cities,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

//Obtiene todas las ofertas de trabajo existentes

export const getAllWorkOffers = () => {

  return (dispatch) => {
    axios
      .get(`/bolsa-de-trabajo/all-job-requests`)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_ALL_JOB_REQUESTS,
          payload: { workOffers: res.data[0], total: res.data[1] }
        });
      })
      .catch((err) => {
        console.error('Error loading work offers:', err)
        // Enviar un payload que indique error para que el componente pueda manejarlo
        dispatch({
          type: actionTypes.GET_ALL_JOB_REQUESTS,
          payload: { workOffers: [], total: 0, error: true }
        });
      })
  }
}


export const createWorkOffer = (workOfferData) => {
  return (dispatch, getState) => {
    dispatch(openEdifySpinner(true));

    const skillsIdToSend = workOfferData.skills.map((el) => parseInt(el.id));
    const workZonesToSend = workOfferData.workZone.map(zone => ({
      city: zone.city,
      jurisdiccion: zone.jurisdiccion,
      name: zone.name
    }));

    const body = {
      contactMethod: workOfferData.contactMethod,
      alternativeContact: workOfferData.alternativeContact,
      workZones: workZonesToSend,
      skills: skillsIdToSend,
      description: workOfferData.description,
      salary: workOfferData.salary,
      salaryType: workOfferData.salaryType,
      immediateStart: workOfferData.inmediateStart,
      startDate: workOfferData.startDate,
      activeUntil: workOfferData.activeUntil,
      currency: "ARS",
    };

    // Verificamos si es desde la página pública
    const isFromPage = workOfferData.captcha;

    if (isFromPage) {
      body.tokenRecaptcha = workOfferData.captcha;
    }

    const url = isFromPage
      ? "/bolsa-de-trabajo/new-job-request/page"
      : "/bolsa-de-trabajo/new-job-request";

    const config = isFromPage
      ? {}
      : {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access-Token-Edify")}`,
        },
      };

    axios
      .post(url, body, config)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        
        // Evento de analytics para oferta de trabajo creada
        const userData = getState().general.userData;
        fireAnalytics("work_offer_created", {
          edify_user_id: userData?.id || "",
          session_id: getSessionId(),
          device_category: getDeviceCategory(),
          category: "publishing",
          action: "work_offer_created",
          work_offer_id: res.data?.id || "",
          is_from_public_page: !!workOfferData.captcha
        });
        
        dispatch(
          openMainModal({
            title: "¡Gracias por publicar tu oferta de trabajo!",
            iconType: "success",
            body: "Tu oferta ya está publicada en nuestra bolsa de trabajo. ¡Muchas gracias!",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModal({
            title: "¡Ups!",
            iconType: "error",
            body: "No hemos podido procesar tu oferta, por favor inténtelo nuevamente en unos minutos o escríbanos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      });
  };
};

export const createWorkBagUser = (workBagData, navigate) => {

  const skillsIdToSend = workBagData.skills.map((el) => el.id);

  const body = {
    name: workBagData.name,
    lastname: workBagData.lastname,
    email: workBagData.email,
    phone: workBagData.phone,
    skills: skillsIdToSend,
    workZone: workBagData.workZone,
    unemploymentFund: workBagData.unemploymentFund,
    currentJob: workBagData.currentJob,
    employmentEndDate: workBagData.employmentEndDate,
    tokenRecaptcha: workBagData.tokenRecaptcha
  }

  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    axios
      .post(`/bolsa-de-trabajo/create`, body, {
        headers: {
          Authorization: "Basic ZWRpZnk6bGFjbGF2ZXNlY3JldGExMjM0",
        },
      })
      .then((res) => {
        dispatch(openEdifySpinner(false));
        if (res.status === 201) {
          
          // Nuevo evento estandarizado
          fireAnalytics("work_bag_registration_success", {
            session_id: getSessionId(),
            device_category: getDeviceCategory(),
            category: "onboarding",
            action: "work_bag_registration_success"
          });
          
          navigate("/bolsadetrabajo/registro-exitoso");
        };

        if (res.data.register.identity_validated === null) {
          dispatch(openWorkBagSuccessModal(res.data.register.email));
        } else {
          dispatch(
            openMainModal({
              title: "¡Gracias por registrarte!",
              body: "Tus datos se han cargado exitosamente en nuestra bolsa de trabajo. Te contactaremos cuando tengamos una oferta que se ajuste a tu perfil. ¡Muchas gracias!",
              isSuccess: true,
              iconType: "success",
              confirmHandler: null,
              customCloseMainModal: () => {
                navigate("/bolsadetrabajo/registro-exitoso");
                dispatch(closeMainModal());
              }
            })
          );
        }
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        if (err.response.status === 409) {
          dispatch(
            openMainModal({
              title: "¡Ups!",
              iconType: "error",
              body: "Ya existe un usuario registrado con ese email. Por favor intenta con otro email o escríbenos a contacto@edify.la ¡Muchas gracias!",
              isSuccess: true,
              confirmHandler: null,
              noLabel: "Cerrar",
            })
          );
        } else {
          dispatch(
            openMainModal({
              title: "¡Ups!",
              iconType: "error",
              body: "No hemos podido procesar tus datos, por favor inténtelo nuevamente en unos minutos o escríbanos a contacto@edify.la ¡Muchas gracias!",
              isSuccess: true,
              confirmHandler: null,
            })
          );
        }
      });
  };
};


//Recupera los datos de todos los registros en bolsa de trabajo

export const getAllWorkBagUsers = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(`/bolsa-de-trabajo/all-registers`, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_ALL_WORKBAG_USERS,
          payload: res.data[0],
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

//Filtra los registros de la bolsa de trabajo

export const filterWorkBagUsers = (filterParams) => {
  // Inicializa la URL base
  let sendUrl = `/bolsa-de-trabajo/get/getByFilter`;

  // Construye los parámetros de consulta
  let queryParams = [];
  if (filterParams.jurisdicciones && filterParams.jurisdicciones.length > 0) {
    queryParams.push(`jurisdicciones=${filterParams.jurisdicciones.join('&jurisdicciones=')}`);
  }
  if (filterParams.skills && filterParams.skills.length > 0) {
    queryParams.push(`skills=${filterParams.skills.join('&skills=')}`);
  }

  // Agrega los parámetros de consulta a la URL base
  if (queryParams.length > 0) {
    sendUrl += `?${queryParams.join('&')}`;
  }

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(sendUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.FILTER_WORKBAG_USERS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

//Trae los datos de una oferta de trabajo por id
export const getWorkOfferById = (id) => {
  return (dispatch) => {
    return axios
      .get(`/bolsa-de-trabajo/job-request/${id}`)
      .then((res) => {
        dispatch({
          type: actionTypes.CURRENT_WORK_OFFER,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

//Envía una solicitud de trabajo a una oferta
export const sendWorkOfferPostulation = (workOfferId) => {
  const formData = new FormData();
  formData.append("jobRequestId", workOfferId.jobRequestId);
  formData.append("email", workOfferId.email);
  formData.append("name", workOfferId.name);
  formData.append("phone", workOfferId.phone);
  formData.append("cv", workOfferId.cv);
  formData.append("coverLetter", workOfferId.coverLetter);

  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    return axios
      .post(`/bolsa-de-trabajo/job-request-postulation`, formData)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModal({
            title: "¡Excelente!",
            body: "Ya le enviamos tus datos al empleador. En breve se pondrán en contacto contigo ¡Mucha suerte!",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
            customCloseMainModal: () => {
              dispatch({
                type: actionTypes.CLOSE_MAIN_MODAL,
              });
              dispatch({
                type: actionTypes.SEND_WORK_OFFER_POSTULATION,
                payload: true,
              });
            },
          })
        );
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModal({
            title: "¡Ups!",
            body: "No pudimos procesar tu postulación, por favor inténtalo nuevamente en unos minutos o escríbenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: true,
            iconType: "error",
            confirmHandler: null,
          })
        );
        dispatch({
          type: actionTypes.SEND_WORK_OFFER_POSTULATION,
          payload: false,
        });
      });
  };
};


//Trae la lista de todas las skills

export const getSkills = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(`/skill/list`, bearerToken)
      .then((res) => {
        let datos = res.data.map((el) => {
          let name = el.name.charAt(0).toUpperCase() + el.name.slice(1);
          return { id: el.id, name: name };
        });
        dispatch(setSkillsToReducer(datos));
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

//Trae las Skills del usuario

export const getUserSkill = (id) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  const url = `/skill/user?userFind=${id}`;
  return (dispatch) => {
    axios
      .get(url, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_USER_SKILL,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};



//Elimina Skill del usuario en el perfil

export const deleteSkillFromProfile = (skillId, id) => {

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  let query = parseInt(skillId);
  return (dispatch) => {
    axios
      .delete(`skill/delete?skillId=${query}`, bearerToken)
      .then((res) => {
        dispatch(
          openMainModal({
            title: "¡Acabas de eliminar un rubro de tu perfil!",
            body: "El mismo no estará visible en tu perfil",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
        dispatch(getUserSkill(id));
      })
      .catch((err) => {
        dispatch(
          openMainModal({
            title: "¡Error!",
            body: "No pudimos eliminar el rubro. Por favor vuelve a intentarlo mas tarde o escríbenos a contacto@edify.la ¡Muchas gracias!",
            isSuccess: true,
            iconType: "error",
            confirmHandler: null,
          })
        );
      });
  };
};

export const clearUserSkills = () => {
  return {
    type: actionTypes.CLEAR_USER_SKILLS,
  };
};

export const addSkill = (id) => {
  return {
    type: actionTypes.ADD_SKILL,
    payload: id,
  };
};

export const removeSkill = (id) => {
  return {
    type: actionTypes.REMOVE_SKILL,
    payload: id,
  };
};

const getPlanReducer = (data) => {
  return {
    type: actionTypes.GET_PLANS,
    payload: data,
  };
};

export const setTerminos = () => {
  return {
    type: actionTypes.SET_TERMINOS,
  };
};

export const getAllPlan = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get("/plan/list", bearerToken)
      .then((res) => {
        dispatch(getPlanReducer(res.data));
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

export const getUserPlan = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get("/plan/user", bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_USER_PLAN,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

export const setPlanId = (id) => {
  return {
    type: actionTypes.SET_PLANID,
    payload: id,
  };
};

export const sendPlan = (planId, navigate) => {
  let planPost = { idPlan: planId };

  let authToken = localStorage.getItem("access-Token-Edify");
  return (dispatch) => {
    axios({
      method: "post",
      url: "/plan/assign",
      params: planPost,
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then((res) => {

      })
      .catch((error) => {

      });
  };
};


export const fetchIdentityPhotos = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  const url = `bolsa-de-trabajo/identity-photos-with-job-board`;
  return (dispatch) => {
    dispatch(fetchIdentityPhotosRequest());
    axios
      .get(url, bearerToken)
      .then((res) => {
        dispatch(
          FetchIdentityPhotosSuccess(res.data)
        );
      })
      .catch((err) => {
        dispatch(FetchIdentityPhotosFailure(err.message));
      });
  };
};

export const validatedIdentityWorker = (id, isValid) => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = {
    headers: { Authorization: `Bearer ${authToken}` },
    'Content-Type': 'application/json',
  };
  return async (dispatch) => {
    try {
      dispatch(openEdifySpinner(true));
      const res = await axios.patch(`/bolsa-de-trabajo/upadate/super/${id}`, {
        identity_validated: isValid,
        job_board_id: id
      }, bearerToken);

      dispatch(openEdifySpinner(false));

      if (res.data.identity_validated) {
        dispatch(
          openMainModal({
            title: "¡Identidad validada!",
            body: "La identidad de este trabajador ha sido validada",
            iconType: "success",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      } else {
        dispatch(
          openMainModal({
            title: "¡Identidad Rechazada!",
            body: "La identidad de este trabajador ha sido rechazada.",
            iconType: "error",
            isSuccess: true,
            confirmHandler: null,
          })
        );
      }
      await dispatch(fetchIdentityPhotos());

    } catch (err) {
      dispatch(openEdifySpinner(false));
      dispatch(
        openMainModal({
          title: "¡Error!",
          body: "No pudimos actualizar los cambios. Revisa los datos ingresados y vuelve a intentar.",
          iconType: "error",
          isSuccess: true,
          confirmHandler: null,
        })
      );
    }
  };
};


export const sendIdentityPhotos = (file, email, navigate) => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("dni_front", file.dniFront);
  formData.append("dni_back", file.dniBack);
  formData.append("selfie", file.selfie);

  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    axios
      .post("/bolsa-de-trabajo/upload-identity-photos", formData)
      .then((res) => {
        dispatch(openEdifySpinner(false));
        dispatch(openInviteToRegisterModal());
      })
      .catch((err) => {
        dispatch(openEdifySpinner(false));
        dispatch(
          openMainModal({
            title: "Ups!",
            body: "Ocurrió un error al enviar las imágenes. Por favor, inténtalo nuevamente en unos minutos o escríbenos a contacto@edify.la. ¡Muchas gracias!",
            isSuccess: true,
            iconType: "error",
            confirmHandler: null,
            noLabel: "Cerrar",
          })
        );
      });
  };
};


export const clearOnboardingForms = () => {
  return {
    type: actionTypes.CLEAR_ONBOARDING_FORM,
  };
};

export const setSuccess = () => {
  return {
    type: actionTypes.SET_SUCCESS,
  };
};


export const createPreRegister = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.PRE_REGISTER_START });
      
      const response = await axios.post('/user/create/pre-register', { email });
      
      dispatch({
        type: actionTypes.PRE_REGISTER_SUCCESS,
        payload: response.data
      });
      
      
      // Nuevo evento estandarizado
      fireAnalytics("onboarding_email_sent", {
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
        category: "onboarding",
        action: "email_sent",
        email: email || ""
      });
      
      return response.data;
    } catch (error) {
      console.error('Error en createPreRegister:', error);
      
      let errorMessage = "Ocurrió un error al enviar el código de verificación.";
      
      if (error?.response?.data?.message) {
        if (error.response.data.message === "El usuario ya está registrado") {
          errorMessage = "Ya contamos con ese email registrado. Por favor, ve al login para acceder a tu cuenta.";
        } else {
          errorMessage = error.response.data.message;
        }
      } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        errorMessage = "Error de conexión. Verifica tu internet e intenta nuevamente.";
      }
      
      dispatch({
        type: actionTypes.PRE_REGISTER_FAIL,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};

export const validateVerificationCode = (email, code) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CODE_VALIDATION_START });
      
      const response = await axios.post('/user/create/validate-code', { email, code });
      
      dispatch({
        type: actionTypes.CODE_VALIDATION_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } catch (error) {
      console.error('Error en validateVerificationCode:', error);
      
      let errorMessage = "Ocurrió un error al validar el código.";
      
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        errorMessage = "Error de conexión. Verifica tu internet e intenta nuevamente.";
      }
      
      dispatch({
        type: actionTypes.CODE_VALIDATION_FAIL,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};


export const resendVerificationCode = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESEND_CODE_START });
      
      const response = await axios.post('/user/create/resend-code', { email });
      
      dispatch({
        type: actionTypes.RESEND_CODE_SUCCESS,
        payload: response.data
      });
      
      // Nuevo evento estandarizado
      fireAnalytics("onboarding_code_resent", {
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
        category: "onboarding",
        action: "code_resent",
        email: email || ""
      });
      
      return response.data;
    } catch (error) {
      console.error('Error en resendVerificationCode:', error);
      
      let errorMessage = "Ocurrió un error al reenviar el código de verificación.";
      
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        errorMessage = "Error de conexión. Verifica tu internet e intenta nuevamente.";
      }
      
      dispatch({
        type: actionTypes.RESEND_CODE_FAIL,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};

export const clearRegistrationFlow = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CLEAR_REGISTRATION_FLOW });
  };
};


// Función auxiliar para hacer login automático después del registro
const performAutoLogin = async (email, password, dispatch) => {
  try {
    // Configuración para el login
    const formData = {
      username: email,
      password: password,
    };

    const config = {
      headers: { Authorization: "Basic ZWRpZnk6bGFjbGF2ZXNlY3JldGExMjM0" },
    };

    // Realizar el login
    const response = await axiosAuth.post("/oauth/token", formData, config);
    
    const { access_token, refresh_token, expires_in, name } = response.data;
    
    // Despachar acciones de login
    dispatch({
      type: actionTypes.SET_ACCESS,
      payload: {
        access: `Bearer ${access_token}`,
        refresh: `Bearer ${refresh_token}`,
        expire: expires_in,
        name: name,
      }
    });

    // Guardar tokens en localStorage
    localStorage.setItem("access-Token-Edify", access_token);
    localStorage.setItem("access-RefreshToken-Edify", refresh_token);
    
    // Marcar como autenticado
    dispatch({ type: actionTypes.LOGIN_SUCCESS });
    dispatch(resetOnboarding());
    localStorage.removeItem("persist:onboardingV2");
    // Obtener datos del usuario
    const getUserHeader = {
      headers: { Authorization: `Bearer ${access_token}` },
    };
    
    const userDataResponse = await axiosAuth.get("/user/data", getUserHeader);
    
    dispatch(viewAccessRequest());
    fireAnalytics("login_success", { 
      category: "authentication", 
      login_user_info: userDataResponse.data.id, 
      edify_user_id: userDataResponse.data.id,
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      login_method: "automatic",
      user_type: userDataResponse.data.type || "",
      action: "login_success"
    });
    dispatch({ type: actionTypes.GET_DATA, payload: userDataResponse.data });
    
    // Activar trial gratuito si está disponible
    if (userDataResponse.data.free_trial?.status === "no-activated") {
      dispatch(activateFreeTrialAuth());
      dispatch(loadUserData());
    }
    
    return userDataResponse.data;
  } catch (error) {
    console.error('Error en auto login después del registro:', error);
    throw error;
  }
};

export const completeUserRegistration = (email, password, skipOnboarding = false) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.COMPLETE_REGISTRATION_START });
      
      localStorage.setItem("EmailRegister", email);
      
      const response = await axios.post('/user/create/register', {
        username: email,
        password: password
      });
     
      dispatch({
        type: actionTypes.COMPLETE_REGISTRATION_SUCCESS,
        payload: { ...response.data, skipOnboarding }
      });
      
      // Analytics
      fireAnalytics("registro_completado_exitoso", { 
        category: "onboarding",
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
        action: "registration_completed"
      });
      
      // Realizar login automático después del registro exitoso
      try {
        const userData = await performAutoLogin(email, password, dispatch);
        
        // Analytics para login automático exitoso
        fireAnalytics("login_automatico_despues_registro", { 
          category: "authentication",
          edify_user_id: userData?.id || "",
          session_id: getSessionId(),
          device_category: getDeviceCategory(),
          login_method: "automatic",
          action: "automatic_login_after_registration"
        });
        
        return { ...response.data, userData };
      } catch (loginError) {
        console.error('Error en login automático:', loginError);
        fireAnalytics("login_automatico_fallido", { 
          category: "authentication",
          session_id: getSessionId(),
          device_category: getDeviceCategory(),
          login_method: "automatic",
          action: "automatic_login_failed"
        });
        return response.data;
      }
      
    } catch (error) {
      console.error('Error en completeUserRegistration:', error);
      
      let errorMessage = "Ocurrió un error al completar el registro.";
      
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        errorMessage = "Error de conexión. Verifica tu internet e intenta nuevamente.";
      }
      
      dispatch({
        type: actionTypes.COMPLETE_REGISTRATION_FAIL,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};
